import { DesktopDatePicker as DatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React from "react";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useOutlinedDatePickerStyles } from "./css";

interface IOutlinedDatePicker {
  name: string;
  clearLabel?: string;
  disabled?: boolean;
  validate?: (value: any) => any;
  format?: string;
  clearable?: boolean;
  label?: string;
  autoComplete?: "current-password" | "username" | "off";
  fillColor?: "white";
}

const OutlinedDatePicker = React.forwardRef<any, IOutlinedDatePicker>(
  (props, ref) => {
    const [translate] = useTranslation();
    const { classes, cx } = useOutlinedDatePickerStyles();
    const {
      name,
      validate,
      disabled,
      clearLabel = translate("clear", "Išvalyti"),
      autoComplete,
      fillColor,
      format = "yyyy-MM-dd",
      ...rest
    } = props;

    return (
      <Field
        name={name}
        validate={validate}
        render={({
          meta: { submitting, error },
          input: { value, ...inputProps },
        }) => {
          const onChange = (date: any) => {
            try {
              if (date instanceof Date) {
                if (isNaN(date.valueOf())) {
                  // Commit null until the user enters the valid date
                  inputProps.onChange(null);
                } else {
                  //3 hours addition is needed because of timezone
                  //otherwise datepicker is subtracting 1 day when entering dates manually
                  inputProps.onChange(
                    new Date(date.getTime() + 3 * 60 * 60 * 1000)
                      .toISOString()
                      .substring(0, 10)
                  );
                }
              } else if (date === null) {
                inputProps.onChange(null);
              } else {
                const parsedDate = new Date(date);
                if (!isNaN(parsedDate.valueOf())) {
                  inputProps.onChange(
                    new Date(parsedDate.getTime() + 3 * 60 * 60 * 1000)
                      .toISOString()
                      .substring(0, 10)
                  );
                } else {
                  inputProps.onChange(null);
                }
              }
            } catch (err) {
              console.error(err);
              inputProps.onChange(null);
            }
          };

          const isDisabled = disabled || submitting;
          const isError = !!error;
          const helperText = isError ? error : null;

          return (
            <DatePicker
              localeText={{
                fieldClearLabel: clearLabel,
                nextMonth: translate("nextMonth", "Kitas mėnuo"),
                previousMonth: translate("previousMonth", "Ankstesnis mėnuo"),
              }}
              {...inputProps}
              disabled={isDisabled}
              value={value ? new Date(value) : null}
              onChange={onChange}
              maxDate={new Date("3999-01-01")}
              minDate={new Date("1900-01-01")}
              inputRef={ref}
              format={format}
              slotProps={{
                field: { clearable: true },
                textField: {
                  ...rest,
                  fullWidth: true,
                  error: isError,
                  helperText: helperText,
                  autoComplete: autoComplete,
                  size: "small",
                  classes: {
                    root: cx(classes.root, {
                      [classes.whiteFilled]: fillColor === "white",
                    }),
                  },
                  inputProps: {
                    ...inputProps,
                    type: "text",  // Leidžiame įvesti ranka
                  },
                },
              }}
            />
          );
        }}
      />
    );
  }
);

export default React.memo(OutlinedDatePicker);
